<template>
  <div>
    <general-table
        :columns="columns"
        :url="route('templates.table')"
        :clickableRow="{route: 'template.view', id: 'id'}"
        :selectActions="selectActions"
        selectable
    >
    </general-table>
  </div>
</template>

<script>
import TemplateTableButton from "../components/TemplateTable/TemplateTableButton";
import MessageTableMessage from "../components/MessageTableMessage";
import TemplateTableActionDelete from "../components/TemplateTableActionDelete";
import TemplateTableOwner from "../components/TemplateTable/TemplateTableOwner";
import {markRaw} from 'vue';

export default {
  components: {
  },
  data() {
    return {
      url: route('templates.table'),
      data: {},
      selectActions: [
        {
            label: "Delete",
            value: "delete",
            component: markRaw(TemplateTableActionDelete),
        }
      ],
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'asc'
      },
      columns: [
        {
          label: "Name",
          name: "name",
          sortable: true,
          width: '250px',
        },
        {
          label: "Message",
          name: "unparsed_message",
          sortable: true,
          component: markRaw(MessageTableMessage),
        },
        {
          label: "Owner",
          name: "owner",
          sortable: false,
          component: markRaw(TemplateTableOwner),
          width: '150px',
        },
        {
          label: "",
          name: "View",
          sortable: false,
          component: markRaw(TemplateTableButton),
          width: '100px',
        }
      ],
    };
  },
  created() {
  },
  methods: {
  },
  computed: {
  }
};
</script>
